var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_74)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6866 13.0957C31.2086 10.7323 27.9016 9.44476 24.48 9.49767C18.2187 9.49767 12.9011 13.7218 11.0051 19.4098C9.99973 22.3905 9.99973 25.6182 11.0051 28.5989H11.0139C12.9187 34.2782 18.2275 38.5023 24.4888 38.5023C27.7208 38.5023 30.4956 37.6756 32.6461 36.2154V36.2095C35.177 34.534 36.9055 31.8972 37.4434 28.9165H24.48V19.6745H47.1175C47.3997 21.2795 47.532 22.9198 47.532 24.5512C47.532 31.8509 44.9232 38.0225 40.3841 42.2025L40.3888 42.2061C36.4116 45.8747 30.9529 48 24.48 48C15.4056 48 7.10718 42.8852 3.03296 34.7808C-0.371021 27.9993 -0.371012 20.0096 3.03298 13.228C7.10721 5.11485 15.4055 -3.06172e-05 24.48 -3.06172e-05C30.4414 -0.0705799 36.2 2.16936 40.5387 6.24359L33.6866 13.0957Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleNegative);
export default __webpack_public_path__ + "static/media/Google - Negative.0f939b74207bfebb015665782efd309e.svg";
export { ForwardRef as ReactComponent };